import { render, staticRenderFns } from "./add_resource.vue?vue&type=template&id=22152dc8&scoped=true"
import script from "./add_resource.vue?vue&type=script&lang=js"
export * from "./add_resource.vue?vue&type=script&lang=js"
import style0 from "./add_resource.vue?vue&type=style&index=0&id=22152dc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22152dc8",
  null
  
)

export default component.exports